export function initWidget() {
  if (window?.bmwidget?.supported){
      return false
  } else {
    return false;
  }
};